// Module
var code = `<modal on-api-ready="\$ctrl.onModalApiReady" form="\$ctrl.deleteLoanForm">
  <modal-header><h2>Confirm</h2></modal-header>
  <modal-body>
    <form name="\$ctrl.deleteLoanForm">
        <div class="modal-body">
          <p>Do you want to delete the selected loan?</p>
          <label>Remarks</label>
          <input class="form-control"
                 type="text"
                 autoComplete="off"
                 ng-model="\$ctrl.remarks" />
        </div>
    </form>
  </modal-body>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/delete-loan/delete-loan-confirmation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;